import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconImageSearch = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconImageSearch",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M200-120q-33 0-56-23t-24-57v-560q0-33 24-56t56-24h160q17 0 29 12t11 28-11 29-29 11H200v560h560v-134q0-17 12-28t28-12 29 12 11 28v134q0 33-23 57t-57 23zm250-200 104-139q6-8 16-8t16 8l110 147q8 10 2 21t-18 11H280q-12 0-18-11t2-21l80-107q6-8 16-8t16 8zm192-200q-74 0-126-52t-52-128 53-127 127-53 128 53 52 127q0 27-8 52t-20 46l94 94q11 11 11 28t-11 28-28 11-28-11l-96-96q-21 14-45 21t-51 7m2-80q42 0 71-29t29-71-29-71-71-29-71 29-29 71 29 71 71 29"
  })
}));